import styled from "styled-components";

export const FilterLabel = styled.label`
display: inline-flex;
align-items: center;
padding: 15px;
margin: 30px;
`

export const FilterField = styled.input`
margin-left: 15px;
width: 240px;
height: 32px;
border-radius: 5px;
`